export const colors = {
  black: '#222222',
  brand: '#364B9C',
  brandDark: '#2E3E82',
  brandLight: '#516FE8',
  error: '#FF2417',
  gray05: '#f5f5f5',
  gray10: '#eeeeee',
  gray20: '#dddddd',
  gray50: '#cccccc',
  gray60: '#aaaaaa',
  gray70: '#999999',
  gray80: '#777777',
  gray90: '#555555',
  white: '#ffffff'
};
